<template>
  <div class="vz-position-sticky" style="top: 10px; z-index:90">
    <template v-if="isMultiOrderRequest">
      <vz-multi-order-total-dispatch @send-form="emit('send-form')" />
      <vz-order-total-price
        @get-price="bonusGetPriceAction"
      >
        <template #buttons>
          <vz-multi-order-total-price-get-btn
            @send-form="emit('send-form')"
            @get-price="orderStore.getOrderPriceAction"
          />
        </template>
      </vz-order-total-price>
    </template>
    <template v-else>
      <vz-multi-order-total-price
        :has-toggle="priceToggle"
        @get-price="orderStore.getOrderPriceAction"
        @create-draft="orderStore.createDraft"
      >
        <template #buttons>
          <vz-multi-order-total-price-get-btn
            @send-form="emit('send-form')"
            @get-price="orderStore.getOrderPriceAction"
          />
        </template>
      </vz-multi-order-total-price>
      <vz-button
        v-if="!orderStore.multiOrder.locked"
        big
        outline
        icon-name="plus"
        variant="primary"
        class="w-100 flex flex-center"
        @click="addRequest()"
      >Добавить адрес</vz-button>
    </template>
  </div>
</template>

<script setup lang="ts">
import VzMultiOrderTotalPrice from '~/components/personal/order/multi-order/vz-multi-order-total-price.vue';
import {useOrderStore} from '~/stores/order';
import VzMultiOrderTotalDispatch from '~/components/personal/order/multi-order/vz-multi-order-total-dispatch.vue';
import VzMultiOrderTotalPriceGetBtn
  from '~/components/personal/order/multi-order/vz-multi-order-total-price-get-btn.vue';
import VzButton from '~/components/ui-kit/vz-button.vue';
import VzOrderTotalPrice from '~/components/personal/order/vz-order-total-price.vue';
import {scrollToElem} from '~/common/functions';

const emit = defineEmits(['send-form'])

const props = defineProps({
  priceToggle: {
    type: Boolean,
    default: true
  }
})

const {$showToast} = useNuxtApp()
const orderStore = useOrderStore()

const validateOrderForm: Function = inject('validateOrderForm', () => {})

const isMultiOrderRequest = computed(() => {
  return orderStore.multiOrder.selectedRequestId
})

function bonusGetPriceAction(isBonus: boolean) {
  if(isBonus) {
    orderStore.getOrderPriceAction()
  }
}

async function addRequest() {
  if (await validateOrderForm()) {
    orderStore.multiOrder.addRequest()
    orderStore.getOrderPriceAction()
    await nextTick()
    scrollToElem('.vz-individual-order-header', { behavior: 'smooth', block: 'start' });
  }
}
</script>

<style lang="scss" scoped>

</style>
